export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'Dashboard',
      displayName: 'menu.dashboard',
      meta: { icon: 'home' },
    },
    {
      name: 'User',
      displayName: 'menu.user.name',
      meta: { icon: 'person' },
      children: [
        {
          name: 'Seller',
          displayName: 'menu.user.seller-list',
          children: [
            { name: 'SellerList', displayName: 'menu.user.seller-list' }, //판매자목록 (판매자)
            { name: 'SellerDailyHistory', displayName: 'menu.user.seller-daily-history' }, // 오늘의판매기록관리 (통계)
          ],
        },
        {
          name: 'Buyer',
          displayName: 'menu.user.buyer-list',
          children: [
            { name: 'BuyerList', displayName: 'menu.user.corp-list' }, // 업체정보관리
            { name: 'CorpDBList', displayName: 'menu.user.corpdb-list' }, // 허용업체관리
            // { name: 'SupportCorpWaitList', displayName: 'menu.support.consult.corp-wait' }, //회원가입상담
          ],
        },
        // { name: 'BuyerManagerInfo', displayName: 'menu.user.buyer-manager-info' } // 담당자정보관리
        // { name: 'BuyerManagerInfo', displayName: 'menu.user.buyer-manager-info' }
      ],
    },
    {
      name: 'Product',
      displayName: 'menu.product.name',
      meta: { icon: 'inventory' },
      children: [
        { name: 'ScrapList', displayName: 'menu.product.scrap-info.scrap-list' }, //고물조회
        { name: 'MarketPriceList', displayName: 'menu.product.price-info.market-price-list' }, //시세조회
        { name: 'ReportList', displayName: 'menu.product.report.report-list' }, //레포트조회(목록)
        { name: 'SpecialPriceList', displayName: 'menu.product.special-info.special-price-list' }, //오늘의특별단가
        // { name: 'ReportSetting', displayName: 'menu.product.report.report-setting' }
      ],
    },
    {
      name: 'Payment',
      displayName: 'menu.payment.name',
      meta: { icon: 'payments' },
      children: [
        { name: 'PaymentItemList', displayName: 'menu.payment.item-payment' },
        { name: 'PaymentBannerList', displayName: 'menu.payment.banner-payment' },
        { name: 'PaymentEntryList', displayName: 'menu.payment.entry-payment' },
      ],
    },
    {
      name: 'Admin',
      displayName: 'menu.admin.name',
      meta: { icon: 'admin_panel_settings' },
      children: [
        { name: 'AdminList', displayName: 'menu.admin.authority.admin-list' },
        { name: 'AppPauseList', displayName: 'menu.admin.authority.app-authority' },
        //{ name: 'GroupAuthority', displayName: 'menu.admin.authority.group-authority' },
        // { name: 'MenuAuthority', displayName: 'menu.admin.authority.menu-authority' },
        // { name: 'Log', displayName: 'menu.admin.log' },
      ],
    },
    {
      name: 'Support',
      displayName: 'menu.support.name',
      meta: { icon: 'support_agent' },
      children: [
        {
          name: 'SupportBannerList',
          displayName: 'menu.support.banner.name',
          children: [
            { name: 'SupportBannerProductList', displayName: 'menu.support.banner.product' },
            { name: 'SupportBannerList', displayName: 'menu.support.banner.seller' },
            { name: 'SupportBannerBuyerList', displayName: 'menu.support.banner.buyer' },
          ],
        },
        { name: 'SupportItemList', displayName: 'menu.support.item' },
        {
          name: 'Event',
          displayName: 'menu.support.event.event',
          children: [
            { name: 'SupportEventList', displayName: 'menu.support.event.event' },
            { name: 'SupportEventWinnerList', displayName: 'menu.support.event.winner' },
          ],
        },
        {
          name: 'Board',
          displayName: 'menu.support.board.name',
          children: [
            { name: 'SupportNoticeList', displayName: 'menu.support.board.notice' },
            { name: 'SupportFAQList', displayName: 'menu.support.board.faq' },
            { name: 'SupportContactList', displayName: 'menu.support.board.contact' },
            { name: 'SupportInquiryList', displayName: 'menu.support.consult.inquiry' },
            { name: 'SupportEduList', displayName: 'menu.support.consult.edu' },
          ],
        },
      ],
    },
    {
      name: 'Statistics',
      displayName: 'menu.statistics.name',
      meta: { icon: 'bar_chart' },
      children: [
        //회원가입
        { name: 'StatisticsSignup', displayName: 'menu.statistics.signup' },
        //결제
        { name: 'StatisticsPayment', displayName: 'menu.statistics.payment' },
        {
          name: 'StatisticsSeller',
          displayName: 'menu.statistics.seller.name',
          children: [
            //비즈콜
            { name: 'Top10Bizcall', displayName: 'menu.statistics.seller.call' },
            //top10 수단,지역, 고물
            { name: 'Top10PrimaryInfo', displayName: 'menu.statistics.seller.pickup-method' },
            //top10, 고물기준 정렬
            { name: 'Top10tradeArea', displayName: 'menu.statistics.seller.pickup-region' },
            //top10, 지역기준 정렬
            { name: 'Top10tradeScraps', displayName: 'menu.statistics.seller.pickup-scrap' },
            //수거자 알림통계
            // { name: 'Top10tradeAlert', displayName: 'menu.statistics.seller.alert' },
          ],
        },
        {
          name: 'StatisticsBuyer',
          displayName: 'menu.statistics.buyer.name',
          children: [
            //업체지역통계
            { name: 'Top10BuyerRegion', displayName: 'menu.statistics.buyer.region' },
            //취급고물통계
            { name: 'Top10BuyerScrap', displayName: 'menu.statistics.buyer.scrap' },
            //매입자알림통계
            // { name: 'Top10BuyerAlert', displayName: 'menu.statistics.buyer.alert' },
          ],
        },

        /*
        { name: 'StatisticsPayment', displayName: 'menu.statistics.payment' },
        { name: 'StatisticsSellerCall', displayName: 'menu.statistics.seller.call' },
        { name: 'StatisticsPickupMethod', displayName: 'menu.statistics.seller.pickup-method' },
        { name: 'StatisticsPickupRegion', displayName: 'menu.statistics.seller.pickup-region' },
        { name: 'StatisticsPickupScrap', displayName: 'menu.statistics.seller.pickup-scrap' },
        { name: 'StatisticsSellerAlert', displayName: 'menu.statistics.seller.alert' },
        { name: 'StatisticsBuyerRegion', displayName: 'menu.statistics.buyer.region' },
        { name: 'StatisticsBuyerScrap', displayName: 'menu.statistics.buyer.scrap' },
        { name: 'StatisticsBuyerAlert', displayName: 'menu.statistics.buyer.alert' },
         */
      ],
    },
    {
      name: 'Notification',
      displayName: 'menu.notification.name',
      meta: { icon: 'notifications' },
      children: [
        { name: 'NotificationUser', displayName: 'menu.notification.user' },
        { name: 'NotificationSystem', displayName: 'menu.notification.system' },
        { name: 'RegmsgList', displayName: 'menu.notification.auto' },
        { name: 'PushList', displayName: 'menu.notification.admin' },
        /*
        { name: 'NotificationSeller', displayName: 'menu.notification.seller' },
        { name: 'NotificationBuyer', displayName: 'menu.notification.buyer' },
        { name: 'NotificationAuto', displayName: 'menu.notification.auto' },
        { name: 'NotificationAdmin', displayName: 'menu.notification.admin' },
         */
      ],
    },
    {
      name: 'Terms',
      displayName: 'menu.terms.terms-main',
      meta: { icon: 'description' },
      children: [
        { name: 'TermsList', displayName: 'menu.terms.terms-main' },
        { name: 'TermsHistoryList', displayName: 'menu.terms.terms-history' },
      ],
    },
  ],
}
